import { mfgInlineInputClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import type { NamedVariantStatus } from "@/lib/manufacturing/namedVariantsClient";

const fieldLabelClass =
  "block text-xs font-semibold text-gray-700 dark:text-zinc-300";
const fieldStackClass = "flex flex-col gap-1.5";

export function ManufacturingNamedVariantMetaFields({
  name,
  code,
  description,
  status,
  onNameChange,
  onCodeChange,
  onDescriptionChange,
  onStatusChange,
  showStatus,
  canArchive,
  codeHint,
  nameAutoFocus,
}: {
  name: string;
  code: string;
  description: string;
  status?: NamedVariantStatus;
  onNameChange: (v: string) => void;
  onCodeChange: (v: string) => void;
  onDescriptionChange: (v: string) => void;
  onStatusChange?: (v: NamedVariantStatus) => void;
  showStatus?: boolean;
  canArchive?: boolean;
  codeHint?: string;
  nameAutoFocus?: boolean;
}) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <div className="space-y-3">
        <label className={fieldStackClass}>
          <span className={fieldLabelClass}>Name</span>
          <input
            className={mfgInlineInputClass}
            placeholder="e.g. 2x6 Joist Upgrade"
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            autoFocus={nameAutoFocus}
          />
        </label>
        <label className={fieldStackClass}>
          <span className={fieldLabelClass}>Code</span>
          <input
            className={mfgInlineInputClass}
            placeholder="Auto-filled from name; edit if needed"
            value={code}
            onChange={(e) => onCodeChange(e.target.value)}
          />
          {codeHint ? (
            <span className="text-[11px] text-gray-500 dark:text-zinc-400">{codeHint}</span>
          ) : null}
        </label>
      </div>
      <div className="space-y-3">
        <label className={fieldStackClass}>
          <span className={fieldLabelClass}>Description</span>
          <textarea
            className={`${mfgInlineInputClass} min-h-[72px]`}
            placeholder="What this upgrade does — AI uses this when applying to recipes"
            value={description}
            onChange={(e) => onDescriptionChange(e.target.value)}
          />
        </label>
        {showStatus && status != null && onStatusChange ? (
          <label className={fieldStackClass}>
            <span className={fieldLabelClass}>Status</span>
            <select
              className={mfgInlineInputClass}
              value={status}
              onChange={(e) => onStatusChange(e.target.value as NamedVariantStatus)}
            >
              <option value="draft">Draft — still authoring</option>
              <option value="active">Active — ready to apply</option>
              {canArchive || status === "archived" ? (
                <option value="archived" disabled={!canArchive && status !== "archived"}>
                  Archived — hide from normal use
                </option>
              ) : null}
            </select>
          </label>
        ) : null}
      </div>
    </div>
  );
}
